const EventConditionRelationTypeList =[
  "EQ", "GE", "GT", "LE", "LT", "NQ"
  
];

export default EventConditionRelationTypeList;